<template>
  <div>
    <integrationNipModal
      ref="integrationNipModal"
      :defaultNip="defaultNip"
      @handlerNipClose="handlerNipClose"
    />
    <a-form id="my_form_styl" v-if="true" :form="form" layout="vertical">
      <a-form-item :label="$t('Status')">
        <a-tag
          style="font-weight: bold"
          color="#029C8E"
          v-if="document.status != 'DO OPISANIA'"
          >{{
            document.status != undefined ? $t(document.status) : $t("NOWY")
          }}</a-tag
        >
        <a-tag style="font-weight: bold" color="#FCB76F" v-else>{{
          $t("DO OPISANIA")
        }}</a-tag>
      </a-form-item>

      <a-form-item :label="$t('File name')">
        <a-tooltip>
          <template slot="title">
            <span>{{ document.NAME }}</span>
          </template>
          <span>{{ document.NAME }}</span>
        </a-tooltip>
      </a-form-item>

      <a-form-item :label="$t('Date of receiving')">
        <template v-if="disableFromResponsible || !currentEdit">{{
          document.date_send
        }}</template>
        <a-date-picker
          v-else
          v-decorator="[
            'date_send',
            {
              rules: [
                {
                  required: true,
                  message: $t('Date of receiving') + $t('required_field'),
                },
              ],
              initialValue: document.date_send
                ? moment(document.date_send, 'YYYY-MM-DD')
                : moment(),
            },
          ]"
        />
      </a-form-item>

      <a-form-item :label="$t('File creation date')">
        <span>{{ document.CREATE_TIME.slice(0, 10) }}</span>
      </a-form-item>

      <a-form-item>
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('ocr_field_tooltip')"
        >
          {{ $t("main_company_n_hub") }}
          <a-icon
            type="file-search"
            :style="{ color: OCRColorIcon.my_company }"
          />
        </a-tooltip>
        <template v-if="disableFromResponsible || !currentEdit">
          <!--{{
           info.my_company[document.my_company]
              ? info.my_company[document.my_company].TITLE
              : ""
          }}-->
          {{ " " }}
        </template>
        <a-input
          @change="changePromptStatus"
          @click="handleChangeMyCompany()"
          :disabled="disableFromResponsible || !currentEdit"
          v-model="myCompanyTitle"
        />
      </a-form-item>

      <a-form-item
        :label="$t('Źródło')"
        v-if="document.responsibleUpload == 514"
      >
        <span>{{ document.userList[document.responsibleUpload].EMAIL }}</span>
      </a-form-item>

      <a-form-item :label="$t('Źródło')" v-else>
        <span>{{
          document.userList[document.responsibleUpload]
            ? document.userList[document.responsibleUpload].NAME +
              " " +
              document.userList[document.responsibleUpload].LAST_NAME
            : ""
        }}</span>
      </a-form-item>

      <a-form-item :label="$t('Document type')">
        <template v-if="disableFromResponsible || !currentEdit">
           {{ $t(document.document_type) }}
        </template>
        <a-select
          v-else
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'document_type',
            {
              rules: [
                {
                  required: true,
                  message: $t('Document type') + $t('required_field'),
                },
              ],
              initialValue: document.document_type,
            },
          ]"
        >
          <a-select-option value="Dokument zwykly">{{
            $t("Regular document")
          }}</a-select-option>
          <a-select-option value="Dokument poufny">{{
            $t("Сonfidential document")
          }}</a-select-option>
          <a-select-option value="FVZ">{{ $t("Invoice") }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item>
        <a-tooltip
          slot="label"
          placement="top"
          :title="$t('ocr_field_tooltip')"
        >
          {{ $t("Contractor") }}
          <a-icon
            type="file-search"
            :style="{ color: OCRColorIcon.kontragent }"
          />
        </a-tooltip>
        <template v-if="disableFromResponsible || !currentEdit"
          ><!--{{
          info.company[document.kontragent]
            ? info.company[document.kontragent].TITLE
            : ""
        }}-->
          {{ "" }}</template
        >
        <div style="display: flex" v-else>
           <a-input 
            @change="changePromptStatus"
            @click="handleChangeContractor()"
            :disabled="disableFromResponsible || !currentEdit"
            v-model="contactorTitle"
          />
          <a-button
            @click="$refs.integrationNipModal.showModal()"
            type="primary"
            icon="plus"
          />
        </div>
      </a-form-item>

      <a-form-item :label="$t('Document name')">
        <template v-if="disableFromResponsible || !currentEdit">{{
          document.title
        }}</template>
        <a-input
          v-else
          v-decorator="[
            'title',
            {
              rules: [{ required: true }],
              initialValue: document.title != undefined ? document.title : '',
            },
          ]"
        />
      </a-form-item>

      <a-form-item :label="$t('Original')">
        <template
          v-if="
            document.status == 'OPISANY' ||
            disableFromResponsible ||
            !currentEdit
          "
          >{{ document.arch_doc_type }}</template
        >

        <a-select
          v-else
          v-decorator="[
            'arch_doc_type',
            {
              rules: [
                {
                  required: true,
                  message: $t('Original') + $t('required_field'),
                },
              ],
              initialValue: document.arch_doc_type || 'Electronic',
            },
          ]"
        >
          <a-select-option value="Electronic">{{
            $t("Electronic")
          }}</a-select-option>
          <a-select-option value="Paper">{{ $t("Paper") }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-modal
        v-model="showFormValidationErrorModal"
        @ok="
          () => {
            showFormValidationErrorModal = false;
            ignoreErrorsAndSubmit();
          }
        "
        @cancel="
          () => {
            showFormValidationErrorModal = false;
          }
        "
        :okText="$t('Save')"
        :cancelText="$t('Close without saving')"
      >
        <p>{{ $t("mandatory_fields_r_unfilled") }}</p>
        <p>{{ $t("what_to_do") }}</p>
      </a-modal>
    </a-form>
    <createCompanyModal
      :companies="bounds.filter((el) => el.label == 'data')"
      ref="create_company_modal"
    />
  </div>
</template>

<script>
import moment from "moment";
import { requestStep } from "@/requestFunc";
import integrationNipModal from "@/components/integrationNipModal";
import { suggestNips } from "@/OCR";
import { mapGetters } from "vuex";
export default {
  props: [
    "document",
    "info",
    "disableFromResponsible",
    "commentsData",
    "currentEdit",
    "user_setup",
    "bounds",
    "COMPANY_LIST",
    "MY_COMPANY_LIST",
    "USER_LIST",
  ],
  components: {
    integrationNipModal,
  },
  computed: { ...mapGetters(["companyFieldForNIP"]) },
  data() {
    return {
      domain: null,
      isNipVisible: false,
      defaultNip: "",
      myCompany: "",
      contractor: "",
      myCompanyTitle: "",
      contactorTitle: "",
      form: this.$form.createForm(this, { name: "first_set" }),
      OCRColorIcon: {
        my_company: "initial",
        kontragent: "initial",
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 9 },
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      file:
        this.document != null
          ? this.document
          : { ID: "", CREATE_TIME: "", TYPE: "" },
      showFormValidationErrorModal: false,
    };
  },
  watch: {
    bounds: function () {
      let whole = this.bounds[this.bounds.length - 1].text;
      let nips = suggestNips(whole);
      this.boundsNips(nips);
    },
  },
  methods: {
    moment,
    boundsNips(nips) {
      var main = false;
      var contractor = false;
      if (nips.extra) {
        if (nips.extra.main)
          main = this.document.arrayCompany.find(
            (x) => x[this.companyFieldForNIP] == nips.extra.main
          );
        if (nips.extra.contractor)
          contractor = this.document.arrayCompany.find(
            (x) => x[this.companyFieldForNIP] == nips.extra.contractor
          );
      } else {
        main = this.document.arrayCompany.find((el) =>
          nips.nips.includes(el[this.companyFieldForNIP])
        );
        //FIXME Брать тип фирмы из настроек и по id из crm_status_list
        contractor = this.document.arrayCompany.find(
          (el) =>
            el.COMPANY_TYPE != "PARTNER" &&
            nips.nips.includes(el[this.info.companyFieldForNIP])
        );
      }
      //FIXME если нашел один нип то второй убирать из массива!!!!!!!
      // if (!main) {
      //   let allNips = this.info.my_company
      //     .map((x) => x[this.companyFieldForNIP])
      //     .filter(Boolean);
      //   let result = [];
      //   for (let i of nips.nips) {
      //     let res = this.findSimilarNIP(i, allNips);
      //     if (res && !result.includes(res)) result.push(res);

      //   if (result.length) {
      //     main = this.info.my_company.find((el) =>
      //       result.includes(el[this.info.companyFieldForNIP])
      //     );
      //   }
      // }
      // if (!contractor) {
      //   let allNips = this.info.company
      //     .filter((x) => x.COMPANY_TYPE != "PARTNER")
      //     .map((x) => x[this.companyFieldForNIP])
      //     .filter(Boolean);
      //   let result = [];
      //   for (let i of nips.nips) {
      //     let res = this.findSimilarNIP(i, allNips);
      //     if (res && !result.includes(res)) result.push(res);
      //   }
      //   if (result.length) {
      //     contractor = this.info.company.find(
      //       (el) =>
      //         result.includes(el[this.companyFieldForNIP]) &&
      //         el.COMPANY_TYPE != "PARTNER"
      //     );
      //   }
      // }

      this.boundsCheck(main && main.ID, "my_company");
      if (contractor) {
        this.boundsCheck(contractor.ID, "kontragent");
      } else {
        if (nips.extra.contractor) this.defaultNip = nips.extra.contractor;
        else if (main && nips.nips.length > 1)
          this.defaultNip = nips.nips.find(
            (x) => x != main[this.companyFieldForNIP]
          );
        this.OCRColorIcon["kontragent"] = this.defaultNip ? "green" : "red";
      }
    },
    handleChangeMyCompany() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          this.myCompany = info.company[0].id.split("_")[1];
          this.myCompanyTitle = info.company[0].title;
        }
      );
    },
    handleChangeContractor() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
        
          this.contractor = info.company[0].id.split("_")[1];
          this.contactorTitle = info.company[0].title;
        }
      );
    },
    findSimilarNIP(searchNIP, allNips) {
      for (let start = 0, end = 5; end < searchNIP.length; start++, end++) {
        let search = searchNIP.slice(start, end);
        let findNIP = allNips.find((x) => x.indexOf(search, start) != -1);
        if (findNIP) return findNIP;
      }
      return "";
    },
    boundsCheck(result, key) {
      if (result) {
        this.form.setFieldsValue({ [key]: result });
        this.OCRColorIcon[key] = "green";
      } else {
        this.OCRColorIcon[key] = "red";
      }
    },
    handlerNipClose(companyID) {
      if (companyID) {
        if (this.COMPANY_LIST[companyID]) {
          this.form.setFieldsValue({
            kontragent: companyID.toString(),
          });
        } else {
          BX24.callMethod("crm.company.get", { id: companyID }, (result) => {
            if (result.error()) console.error(result.error());
            else {
              let companyInfo = result.data();
              this.info.company.splice(0, 0, companyInfo);
              this.COMPANY_LIST = Object.assign({}, this.COMPANY_LIST, {
                [companyID]: companyInfo,
              });
              this.form.setFieldsValue({
                kontragent: companyInfo.ID,
              });
            }
          });
        }
      }
    },
    ignoreErrorsAndSubmit(comments = this.comments) {
      this.form.validateFields((err, values) => {
        this.changeSpinning();
        requestStep(this.saveValues(values, comments))
          .done((data) => {
            var res = JSON.parse(data);
            this.document.status = res.status;
            this.document.document_type = values.document_type;
            this.document.my_company = values.my_company;
            this.document.kontragent = values.kontragent;
            this.onback(res.status, this.document);
            this.document.title =
              values.title != undefined
                ? values.title
                : this.document.title != undefined
                ? this.document.title
                : "";
            this.$message.success(this.$t("Document registration completed!"));
          })
          .fail((e) => {
            console.error(e);
            this.onback();
            this.$message.error(this.$t("Documen registration error"));
          })
          .always(() => {
            this.changeSpinning();
          });
      });
    },
    submit(comments) {
      this.form.validateFields((err) => {
        if (err) {
          this.showFormValidationErrorModal = true;
          this.comments = comments;
        } else {
          this.ignoreErrorsAndSubmit(comments);
        }
      });
    },
    saveValues(values, comments) {
      if (
        values.date_send != undefined &&
        values.date_send != "" &&
        values.date_send != "Invalid date"
      ) {
        values.date_send = moment(values.date_send).format("YYYY-MM-DD");
      } else {
        values.date_send = "";
      }

      let data = {
        run: "savedocumentstage1",
        title: this.document.title != undefined ? this.document.title : "",
        date_send: values.date_send,
        CREATE_TIME: this.document.CREATE_TIME,
        document_type: values.document_type,
        comments: comments,
        name: this.document.NAME,
        my_company: this.myCompany,
        kontragent: this.contractor,
        ID: this.document.ID,
        url: this.document.DOWNLOAD_URL,
        DETAIL_URL: this.document.DETAIL_URL,
        arch_doc_type: values.arch_doc_type,
      };
      for (let key in values) {
        if (values[key] != this.document[key]) {
          data[key] = {
            old: this.document[key],
            new: values[key],
          };
        }
      }
      return data;
    },
    onback(status, doc_record) {

      this.$emit("onback", {
        unshift_elem: status == "ZAREJESTROWANE" ? false : true,
        remove_elem: this.document.ID,
        doc_record,
      });
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
    getCompany(id) {
      let company = this.document.arrayCompany.find((x) => x.ID == id);
      return company ? company.TITLE : '';
    },
    showDrawerNIP() {
      this.isNipVisible = true;
    },
    onCloseNIP() {
      this.isNipVisible = false;
    },
  },
  async mounted() {
    this.contractor = this.document.kontragent;
    this.contactorTitle = this.getCompany(this.document.kontragent);
    this.myCompany = this.document.my_company;
    this.myCompanyTitle = this.getCompany(this.document.my_company);
    if (!this.document.document_type) this.document.document_type = "FVZ";
    let auth = BX24.getAuth();
    this.domain = auth.domain;
  },
};
</script>

<style scoped>
.first_form label {
  font-weight: 500;
}
</style>